import classNames from "classnames";
import { isEmpty } from "lodash";
import { BiCheckCircle, BiXCircle } from "react-icons/bi";

export default function QuestionSubmissionView({
  submission,
  onQuestionsChanged,
  updateAnswerHandler,
}) {
  const answers = submission?.answers;

  const questions = answers?.map((answer) => answer?.questionId);
  if (isEmpty(questions) || questions?.length === 0 || !questions) return null;
  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-xl font-bold">Questions Information</h2>
      {answers &&
        answers.map((answer, index) => {
          const question = answer?.questionId;
          return (
            <div
              className="border rounded-md shadow-lg p-2 flex flex-col gap-4 overflow-hidden"
              key={question?._id}
            >
              <div className="font-bold bg-gray-200 px-2 py-3 m-[-8px] rounded-md flex items-center justify-between">
                <h3 className="flex items-center gap-2">
                  Question {index + 1} -
                  {answer.isCorrect ? (
                    <span className="text-green-500 flex items-center gap-2 font-bold">
                      Correct
                      <span>
                        <BiCheckCircle size={16} />
                      </span>
                    </span>
                  ) : (
                    <span className="text-red-500 flex items-center gap-2">
                      Incorrect <BiXCircle size={16} />
                    </span>
                  )}
                </h3>

                <div className="flex items-center gap-2 me-2 flex-wrap">
                  {answer.isCorrect ? (
                    <button
                      type="button"
                      className="bg-red-500 rounded-full p-2 px-3 hover:bg-red-400 duration-300 flex items-center gap-2 text-white text-xs"
                      onClick={() => updateAnswerHandler(answer, false)}
                    >
                      <BiXCircle size={16} color="white" /> Mark as Incorrect
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="bg-green-500 rounded-full p-2 px-3 hover:bg-green-400 duration-300 flex items-center gap-2 text-white text-xs"
                      onClick={() => updateAnswerHandler(answer, true)}
                    >
                      <BiCheckCircle size={16} color="white" /> Mark as Correct
                    </button>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-2 *:py-3">
                <div className="flex-1 flex  gap-2 border-b">
                  <div className="flex flex-col flex-1 gap-2">
                    <p className="font-bold">Title: </p>
                    <p>{question.title}</p>
                  </div>
                  <div className="flex flex-col flex-1 gap-2">
                    <p className="font-bold">Title (Arabic): </p>
                    <p>{question.titleAr}</p>
                  </div>
                </div>
                <div className="flex-1 flex  gap-2 border-b">
                  <div className="flex flex-col flex-1 gap-2">
                    <p className="font-bold">Description: </p>
                    <p>{question.description}</p>
                  </div>
                  <div className="flex flex-col flex-1 gap-2 ">
                    <p className="font-bold">Description (Arabic): </p>
                    <p>{question.descriptionAr}</p>
                  </div>
                </div>
                <div className="flex-1 flex gap-2 border-b">
                  <div className="flex flex-col flex-1 gap-2">
                    <p className="font-bold">Points: </p>
                    <p>{question.points}</p>
                  </div>
                  <div className="flex flex-col flex-1 gap-2">
                    <p className="font-bold">Type: </p>
                    <p>{getQuestionType(question.type)}</p>
                  </div>
                </div>
                <div className="flex-1 flex gap-2 border-b">
                  <div className="flex flex-col flex-1 gap-2">
                    <p className="font-bold">Points Earned: </p>
                    <p>{answer?.pointsEarned}</p>
                  </div>
                  <div className="flex flex-col flex-1 gap-2">
                    <p className="font-bold">Is Correct: </p>
                    <p className="font-bold">
                      {answer?.isCorrect ? (
                        <span className="flex items-center gap-2 text-green-500">
                          <BiCheckCircle color="green" size={20} /> Yes
                        </span>
                      ) : (
                        <span className="flex items-center gap-2 text-red-500">
                          <BiXCircle color="red" size={20} /> No
                        </span>
                      )}
                    </p>
                  </div>
                </div>
                {question.type === "single" || question.type === "multiple" ? (
                  <OptionsViewTable options={question.options} />
                ) : null}
                {question.type === "truefalse" ? (
                  <div className="flex-1 flex  gap-2 border-b">
                    <p className="font-bold">Is the statement true? </p>
                    <p>
                      {question.isTrue ? (
                        <span className="flex items-center gap-2">
                          <BiCheckCircle color="green" size={20} /> Yes
                        </span>
                      ) : (
                        <span className="flex items-center gap-2">
                          <BiXCircle color="red" size={20} /> No
                        </span>
                      )}
                    </p>
                  </div>
                ) : null}
                {question.type === "essay" ? (
                  <div className="flex-1 flex  gap-2 ">
                    <p className="font-bold">Expected Answer: </p>
                    <p>{question.expectedAnswer}</p>
                  </div>
                ) : null}
                {question.type === "matching" ? (
                  <MatchingPairsViewTable
                    matchingPairs={question.matchingPairs}
                  />
                ) : null}

                <hr />
                <div className="flex flex-col gap-2">
                  <h3 className="font-bold text-lg">Agent Answer: </h3>
                  {question.type === "essay" ? (
                    <div className="flex-1 flex  gap-2 ">
                      <p>{answer?.textAnswer ? "Yes" : "No"}</p>
                    </div>
                  ) : null}
                  {question.type === "truefalse" ? (
                    <div className="flex-1 flex  gap-2 ">
                      <p>
                        {answer?.textAnswer ? (
                          <span className="flex items-center gap-2">
                            <BiCheckCircle color="green" size={20} /> Yes
                          </span>
                        ) : (
                          <span className="flex items-center gap-2">
                            <BiXCircle color="red" size={20} /> No
                          </span>
                        )}
                      </p>
                    </div>
                  ) : null}

                  {question.type === "matching" ? (
                    <MatchingPairsViewTable
                      matchingPairs={question.matchingPairs}
                      answer={answer}
                    />
                  ) : null}
                  {question.type === "single" ||
                  question.type === "multiple" ? (
                    <OptionsViewTable
                      options={question.options}
                      answer={answer}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
    </section>
  );
}

function OptionsViewTable({ options, answer }) {
  const filterCorrectAnswer = options?.filter((option) =>
    answer?.selectedOptions?.find((o) => o === option._id.toString())
  );

  const filteredOptions =
    filterCorrectAnswer?.length > 0 ? filterCorrectAnswer : options;
  if (
    isEmpty(filteredOptions) ||
    filteredOptions?.length === 0 ||
    !filteredOptions
  )
    return null;

  return (
    <div className="flex-1 flex flex-col  gap-2">
      {filterCorrectAnswer?.length > 0 ? null : (
        <p className="font-bold">Options</p>
      )}
      <table>
        <thead>
          <tr>
            <th className="py-3 px-6">#</th>
            <th className="py-3 px-6">Title</th>
            <th className="py-3 px-6">Title (Arabic)</th>
            <th className="py-3 px-6">Is Correct</th>
          </tr>
        </thead>
        <tbody>
          {filteredOptions?.map((option, index) => {
            return (
              <tr className="border-b " key={option._id}>
                <td className="py-3 px-6 border-l text-center">{index + 1}</td>
                <td className="py-3 px-6 border-l">{option.text}</td>
                <td className="py-3 px-6 border-l">{option.textAr}</td>
                <td
                  className={classNames(
                    "py-3 px-6 border-l font-bold flex items-center gap-2",
                    option.isCorrect ? "text-green-500" : "text-red-500"
                  )}
                >
                  {option.isCorrect ? (
                    <>
                      <BiCheckCircle color="green" size={20} /> Correct
                    </>
                  ) : (
                    <>
                      <BiXCircle color="red" size={20} /> Incorrect
                    </>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function MatchingPairsViewTable({ matchingPairs, answer }) {
  function getAnswer() {
    if (!answer) return null;
    if (
      !answer?.matchingAnswers ||
      !matchingPairs ||
      matchingPairs.length === 0
    )
      return [];
    const agentAnswer = [];
    const matchingAnswers = answer?.matchingAnswers;

    // Create a map of all items (left and right) from matchingPairs for easy lookup
    const allItems = {};
    matchingPairs.forEach((pair) => {
      allItems[pair.left.id] = pair.left;
      allItems[pair.right.id] = pair.right;
    });

    // Transform matchingAnswers into the same format as matchingPairs
    matchingAnswers.forEach((userAnswer, index) => {
      const leftItem = allItems[userAnswer.leftId];
      const rightItem = allItems[userAnswer.rightId];

      if (leftItem && rightItem) {
        agentAnswer.push({
          left: leftItem,
          right: rightItem,
          _id: userAnswer._id || `answer_${index}`,
        });
      }
    });

    return agentAnswer;
  }
  const answers = getAnswer();
  const pairs = answers || matchingPairs;

  if (isEmpty(pairs) || pairs?.length === 0 || !pairs) return null;
  return (
    <div className="flex-1 flex flex-col  gap-2 ">
      {!answers ? <p className="font-bold">Matching Pairs:</p> : null}
      <table>
        <thead>
          <tr>
            <th className="py-3 px-6">#</th>
            <th className="py-3 px-6">Left / Left (Arabic)</th>
            <th className="py-3 px-6">Right / Right (Arabic)</th>
          </tr>
        </thead>
        <tbody>
          {pairs?.map((pair, index) => {
            return (
              <tr className="border-b " key={pair._id}>
                <td className="py-3 px-6 border-l text-center">{index + 1}</td>
                <td className="py-3 px-6 border-l">
                  {pair.left.text} / {pair.left.textAr}
                </td>
                <td className="py-3 px-6 border-l">
                  {pair.right.text} / {pair.right.textAr}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function getQuestionType(type) {
  if (type === "single") return "Multiple Choice - Single Answer";
  if (type === "multiple") return "Multiple Choice - Multiple Answers";
  if (type === "truefalse") return "True or False Question";
  if (type === "essay") return "Essay Question";
  if (type === "matching") return "Matching Question";
  return "";
}
